import type { Template } from "@/types";

export const LA_02_H2_V0: Template[] = [
{
    id: "la-02-h2v0-01",
    name: "LA 01 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 52, y: 51, width: 533, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 689, y: 51, width: 533, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-02",
    name: "LA 02 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 52, y: 51, width: 533, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 101, width: 443, height: 273, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-03",
    name: "LA 03 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 74, y: 74, width: 485, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 713, y: 74, width: 485, height: 328, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-04",
    name: "LA 04 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 65, y: 98, width: 403, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 538, y: 0, width: 737, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-05",
    name: "LA 05 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 806, y: 98, width: 403, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 737, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-06",
    name: "LA 06 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 51, y: 51, width: 536, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 637, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-07",
    name: "LA 07 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 687, y: 51, width: 536, height: 375, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-08",
    name: "LA 08 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 96, y: 112, width: 444, height: 254, rotation: 0, imageRotation: 0 },
            { id: "2", x: 689, y: 51, width: 533, height: 374, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-09",
    name: "LA 09 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 52, y: 51, width: 533, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 112, width: 444, height: 254, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-02-h2v0-10",
    name: "LA 10 - H2V0",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-02-h2_v0_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 129, y: 122, width: 376, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 673, y: 39, width: 566, height: 396, rotation: 0, imageRotation: 0 }
    ],
}
];